export interface ServiceCard {
  id: string;
  title: string;
  description: string;
  icon: string;
  route: string;
  color: string;
}

export const services: ServiceCard[] = [
  {
    id: "health",
    title: "Health Insurance",
    description: "Compare top health plans with cashless hospital coverage, pre-existing disease coverage, and family floater options. Expert guidance on network hospitals and claim settlement.",
    icon: "ri-hospital-line",
    route: "/health-insurance",
    color: "bg-red-50 text-red-600",
  },
  {
    id: "term",
    title: "Term Insurance",
    description: "Protect your family's financial future with the best term plans. Compare premiums, riders, claim settlement ratios, and get unbiased expert recommendations.",
    icon: "ri-shield-check-line",
    route: "/term-insurance",
    color: "bg-blue-50 text-blue-600",
  },
  {
    id: "life",
    title: "Life Insurance",
    description: "Endowment, ULIP, and whole life plans with guaranteed returns. Find policies that match your life goals with our expert advisors.",
    icon: "ri-heart-pulse-line",
    route: "/life-insurance",
    color: "bg-rose-50 text-rose-600",
  },
  {
    id: "car",
    title: "Car Insurance",
    description: "Compare comprehensive and third-party motor insurance. Get the best IDV, zero depreciation, roadside assistance, and instant policy issuance.",
    icon: "ri-car-line",
    route: "/car-insurance",
    color: "bg-orange-50 text-orange-600",
  },
  {
    id: "travel",
    title: "Travel Insurance",
    description: "Single trip and multi-trip travel insurance with medical coverage, trip cancellation, baggage loss, and emergency evacuation benefits.",
    icon: "ri-plane-line",
    route: "/travel-insurance",
    color: "bg-sky-50 text-sky-600",
  },
  {
    id: "marine",
    title: "Marine Insurance",
    description: "Cargo and hull insurance for import/export businesses. Protect your shipments against transit risks, damage, and loss with tailored marine policies.",
    icon: "ri-ship-line",
    route: "/marine-insurance",
    color: "bg-teal-50 text-teal-600",
  },
  {
    id: "corporate",
    title: "Corporate Insurance",
    description: "Comprehensive business insurance packages including property, liability, workers compensation, and professional indemnity for enterprises of all sizes.",
    icon: "ri-building-line",
    route: "/corporate-insurance",
    color: "bg-indigo-50 text-indigo-600",
  },
  {
    id: "group-health",
    title: "Group Health Insurance",
    description: "Employee health benefits with customizable coverage, maternity benefits, wellness programs, and corporate wellness dashboards for HR teams.",
    icon: "ri-team-line",
    route: "/group-health-insurance",
    color: "bg-emerald-50 text-emerald-600",
  },
  {
    id: "mutual-funds",
    title: "Mutual Funds",
    description: "Expert-curated mutual fund portfolios based on your risk profile and goals. SIP and lump sum investments with regular portfolio reviews and rebalancing.",
    icon: "ri-bar-chart-grouped-line",
    route: "/mutual-funds",
    color: "bg-amber-50 text-amber-600",
  },
  {
    id: "sip",
    title: "SIP Investments",
    description: "Start your wealth creation journey with systematic investment plans. Calculate returns, choose the right funds, and automate your investments.",
    icon: "ri-line-chart-line",
    route: "/sip-investments",
    color: "bg-green-50 text-green-600",
  },
  {
    id: "retirement",
    title: "Retirement Planning",
    description: "Build your retirement corpus with annuity plans, NPS, and pension schemes. Calculate how much you need and get a personalized retirement roadmap.",
    icon: "ri-timer-line",
    route: "/retirement-planning",
    color: "bg-violet-50 text-violet-600",
  },
  {
    id: "financial",
    title: "Financial Planning",
    description: "Holistic financial planning including goal setting, asset allocation, tax optimization, estate planning, and wealth preservation strategies.",
    icon: "ri-pie-chart-line",
    route: "/financial-planning",
    color: "bg-cyan-50 text-cyan-600",
  },
];